import { http } from '@/http'

export default {
  list() {
    return http.get('/operational-payment-concepts')
  },
  listByStatus(status) {
    return http.get('/operational-payment-concepts', { params: { status } })
  },
  get(id) {
    return http.get(`/operational-payment-concepts/${id}`)
  },
  save(data) {
    return http.post('/operational-payment-concepts', data)
  },
  update(id, data) {
    return http.put(`/operational-payment-concepts/${id}`, data)
  },
  changeStatus(id, status) {
    return http.put(`/operational-payment-concepts/${id}/status`, null, { params: { status } })
  },
}
